const style = {
  display: "flex",
  backgroundColor: "#F0F0F0",
  outline: "solid 1px #C0C0C0",
  height: 48
};

export function HeaderContainer(props) {
  return (<>
    <div style={ { ...style, ...{ borderTopLeftRadius: props.rounding === "left" ? 12 : 0, borderTopRightRadius: props.rounding === "right" ? 12 : 0 } } }>
      { props.children }
    </div>
  </>);
}
